<form #stateForm="ngForm" class="row">
	<mat-form-field class="col">
		<mat-label>{{ label }}</mat-label>
		<input matInput aria-label="State" type="text" [placeholder]="placeholder" [id]="id" [name]="name"
			[matAutocomplete]="auto" [(ngModel)]="selectedState.STATE_NAME" #searchString="ngModel" #searchStringInput
			[value]="selectedState.STATE_NAME" [required]="required" (ngModelChange)="checkForId(searchString)"
			[readonly]="disabledState" [disabled]="disabled" />
		<button mat-icon-button matSuffix [attr.aria-label]="'State Valid'"
			[color]="selectedState && selectedState.ID ? 'primary' : 'warn'" tabindex="-1" [disabled]="disabled">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && (stateForm.dirty || selectedState.ID! > 0)">
				{{ selectedState.ID ? "done" : "close" }}
			</mat-icon>
		</button>
	</mat-form-field>
	<app-msg *ngIf="!isLoading" class="msg-position"
		[msg]="{MSG:searchString.errors?.['idRequired'], SUCCESS:!searchString.errors?.['idRequired']}"></app-msg>
	
	<app-msg *ngIf="displayRequiredMessage && !isLoading && !searchString.errors?.['idRequired']" class="msg-position"
		[msg]="requiredMsg"></app-msg>

	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
		<ng-container *ngIf="!isLoading">
			<mat-option *ngFor="let state of states" [value]="state">
				{{state.STATE_NAME}}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
</form>